import operations from '~/helpers/device-operations';
import { Operation } from '~/interfaces/device.interface';
import { LegrandGateway } from './LegrandGateway.model';
import { feedbackGiven } from '~/helpers/fields-description';
import { FieldObject } from '~/interfaces/field.interface';

export class BNC3 extends LegrandGateway {

    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
    feedback_given?: boolean;

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.triggerLogsDump({ callback: this.triggerLogsDump }),
        ]);
    }

    get fieldFeedbackGiven(): FieldObject | undefined {
        return feedbackGiven(this.feedback_given);
    }
}
